export default {
  namespaced: true,
  state: {
    all: [],
    loading: false,
  },
  getters: {
    all: state => state.all,
    find: state => state.all.find(client => client.id == Vue.$route.params.id),
    loading: state => state.loading,
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, clients) {
      state.all = clients.map(c => ({...c, $type: 'Client' }))
      state.loading = false
    },
    set(state, client) {
      state.all = state.all.filter(o => o.id != client.id)
      state.all.push({ ...client, $type: 'Client' })
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    },
  },
  actions: {
    fetchAll({ commit }) {
      this.$authorize('list', 'Client')

      commit('startLoading')
      return Vue.$http
        .get('admin/clients')
        .then(response => commit('setAll', response.data))
        .finally(response => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Client')

      return Vue.$http.get(`admin/clients/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, client) {
      this.$authorize('create', 'Client')

      return Vue.$http.post('admin/clients', { client }).then(response => {
        commit('set', response.data)
        return response
      })
    },
    update({ commit }, client) {
      this.$authorize('edit', 'Client')

      return Vue.$http
        .patch(`admin/clients/${client.id}`, { client })
        .then(response => commit('set', response.data))
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Client')

      return Vue.$http.delete(`admin/clients/${id}`).then(response => commit('remove', id))
    },
  },
}
